import { render, staticRenderFns } from "./StockSkus.vue?vue&type=template&id=73dfdce5"
import script from "./StockSkus.vue?vue&type=script&lang=ts"
export * from "./StockSkus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports